import { differenceInYears, parseISO } from 'date-fns';
import { FieldValidationError } from '../../../types/form/field-validation-error';
export const getMinAgeValidationRule = (minAge) => {
    return (dateString) => {
        const date = parseISO(dateString);
        const isValid = differenceInYears(Date.now(), date) >= minAge;
        if (!isValid) {
            return FieldValidationError.MinAge;
        }
    };
};
//# sourceMappingURL=min-age-validation-rule.js.map